export default "__VITE_ASSET__a8806b19__"